import { mapState, mapGetters } from 'vuex';
import { smartFocus } from '@/utils/uiHelper';
import SiteNotFound from '@/components/sections/SiteNotFound/SiteNotFound.vue';
import ErrorMessage from '@/components/sections/ErrorMessage/ErrorMessage.vue';
import Loading from '@/components/widgets/Loading/Loading.vue';
import MarketingContent from '@/components/sections/MarketingContent/MarketingContent.vue';

// @vue/component
export default {
  name: 'Launchpad',
  components: {
    SiteNotFound,
    ErrorMessage,
    Loading,
    MarketingContent,
  },
  mounted() {
    this.$store.dispatch('setupBasicInfo', {
      query: this.$route.query,
      params: this.$route.params,
    }).then(() => {
      if (this.loginType === 'account') {
        this.$store.dispatch('getSiteInfo', this.$route);
      } else {
        this.$store.commit('setSiteInfo', this.$store.state.site.siteInfo);
        this.$store.dispatch('setPageTitle', this.$route.meta.title);
      }
    });

    document.body.addEventListener('focus', (e) => {
      const t = e.target.closest('.w-input');
      if (t) {
        const i = t.querySelector('.w-input__input');
        if (i && i.value === '') t.classList.add('is-moved');
      }
    }, true);

    document.body.addEventListener('blur', (e) => {
      const t = e.target.closest('.w-input');
      if (t) {
        const i = t.querySelector('.w-input__input');
        if (i && i.value === '') t.classList.remove('is-moved');
      }
    }, true);

    document.querySelectorAll('.w-input .w-input__input').forEach((el) => {
      if (el.value !== '') {
        el.parentElement.classList.add('is-moved');
      }
    });

    smartFocus();
  },
  computed: {
    ...mapState({
      siteNotFound: (state) => state.site.siteNotFound,
      siteLoading: (state) => {
        if (state.login.loginType === 'generic' && !state.login.waf) return true;
        return state.site.siteLoading;
      },
      fatalError: (state) => state.login.fatalError.error,
      allowBranding: (state) => state.site.siteInfo.displayOptions.hasTeamworkBranding,
      loginType: (state) => state.login.loginType,
      siteName: (state) => state.site.siteInfo.name,
      siteLogo: (state) => state.login.meta.isIframe ? '' : state.site.siteInfo.logo, // eslint-disable-line
      isIframe: (state) => state.login.meta.isIframe,
      inAppLogin: (state) => state.login.loginType === 'app',
      inGenericLogin: (state) => state.login.loginType === 'generic',
      isPersonaCapture: (state) => state.login.formState === 'persona-capture',
      isEmailValidation: (state) => state.login.formState === 'email-validation',
    }),
    ...mapGetters({
      bodyClasses: 'bodyClasses',
    }),
    showSiteLogo() {
      return !this.siteNotFound && this.siteLogo && !this.$route.meta.hideSiteLogo;
    },
    displayMarketingContent() {
      return !this.siteLoading && !this.siteNotFound &&
        !this.isIframe && !this.inAppLogin &&
        this.inGenericLogin && this.$route.name === 'Login';
    },
  },
  watch: {
    $route() {
      this.$store.dispatch('setPageTitle', this.$route.meta.title);
    },
    displayMarketingContent(value) {
      if (value) this.loadVWO();
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
    loadVWO() {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'vwoCode';
      script.text = `
        window._vwo_code || (function() {
        var account_id=720001,
        version=2.1,
        settings_tolerance=2000,
        hide_element='body',
        hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;',
        /* DO NOT EDIT BELOW THIS LINE */
        f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={nonce:v&&v.nonce,use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}v&&t.setAttribute('nonce',v.nonce);d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var n=this.getSettings(),i=d.createElement('script'),r=this;t=t||{};if(n){i.textContent=n;d.getElementsByTagName('head')[0].appendChild(i);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200||o.status===304){_vwo_code.addScript({text:o.responseText})}else{_vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}_vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var n=this.hide_element(),i=n?n+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var i=d.createElement('div');i.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;display: block !important;';i.setAttribute('id','_vis_opt_path_hides');i.classList.add('_vis_hide_layer');t.parentNode.insertBefore(i,t.nextSibling)}var o=window._vis_opt_url||d.URL,s='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(o)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:s})}else{this.load(s+'&x=true')}}};w._vwo_code=code;code.init();})();
      `;
      document.head.appendChild(script);

      const vwoOnVariationApplied = (data) => {
        if (!data) return;
        const { 1: campaign, 2: variation } = data;
        this.$store.dispatch('appendExperimentTracking', { campaign, variation });
      };

      window.VWO = window.VWO || [];
      window.VWO.push(['onVariationApplied', vwoOnVariationApplied]);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/App.js